<template>
  <div class="home">
    <div class="home-swipe">

      <van-notice-bar
                      color="#ff6600"
                      background="#fff"
                      left-icon="volume-o"
                      :text="notice"/>
    </div>
    <form action="/">
      <van-search sticky v-model="searchValue" placeholder="请输入关键词搜索 如面膜" shape="square"
                  background="#rgb(239 156 72)" @search="mysearch" >
      </van-search>

    </form>


    <van-dialog v-model:show="showDialog"  title="复制成功" :show-confirm-button="false" >
      <div>
        <br>
        <div style="text-align:center">
            <button  @click="gotoTb" style="text-align: center;background:#ff6600;color:#fff;
          background-color: #ff6600;
          padding: 4px;
          font-size: 16px;
          font-weight: 600;"
                    v-clipboard:copy="copy_pass"
                    v-clipboard:success="onCopy"
                     v-clipboard:error="onError">打开淘宝App抢购</button>
        </div>
        <br>
      </div>
    </van-dialog>

    <van-tabs v-model="activeClass" sticky @change="onTabChange" >
      <van-tab v-for="(item,i) in classList" :title="titleList[i]" :key="item" >
        <div class="goods-list">
          <!-- <div v-for="(item, idx) in list" :key="idx" v-clipboard:copy="item.status"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError">

             <van-card
                   num=""
                   :origin-price="item.price"
                   desc=""
                   :title="item.title"
                   :thumb="item.imgUrl"
           >
             <template #title>
               <div class="van-multi-ellipsis--l2">
                 <span style="font-size:16px">{{item.title}}</span>
               </div>
             </template>
             <template #origin-price	>
               <div class="van-multi-ellipsis--l2">
                 <span style="font-size:16px">￥{{item.price}}</span>
               </div>
             </template>
             <template #num>
               <van-button color="linear-gradient(to right, #ff6034, #ee0a24)" size="small">点我复制</van-button>
             </template>
           </van-card>
           </div>-->
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" >
              <van-row>
                <van-col v-for="(item, idx) in list" :key="idx" span="12">
                  <div  v-if="item.liveDay == null" :class='idx%2==0?"good-item":"good-item2"'>
                    <div class="good-box">
                      <img v-lazy="item.imgUrl" />
                      <div class="name">{{item.title}}</div>
                      <div class="info">
                        <div  class="slogan"  @click="deleteData(item.id)"> 删除 </div>
                        <div  class="slogan"  @click="getData(item.id)"> 点我复制 </div>

                      </div>
                    </div>
                  </div>
                  <div  v-if="item.liveDay != null" :class='idx%2==0?"good-item":"good-item2"'  v-clipboard:copy="item.status"
                  >
                    <div class="good-box">
                      <img v-lazy="item.imgUrl" />
                      <div class="name">{{item.title}}</div>
                      <div class="info">
                        <div class="slogan" @click="openJd(item.liveDay)"> 点我去京东 </div>
                      </div>
                    </div>
                  </div>
                </van-col>
              </van-row>
            </van-list>
          </van-pull-refresh>
        </div>
      </van-tab>
    </van-tabs>


  </div>
</template>


<script>

  import { AES, enc, mode, pad } from 'crypto-js'
  // import ClipboardJS from 'clipboard'
  import * as clipboard from "clipboard-polyfill/text";

  import {
    Search,
    Swipe,
    SwipeItem,
    Row,
    Col,
    NavBar,
    Icon,
    Tab,
    Tabs,
    ActionSheet,
    Popup,
    Image,
    NoticeBar,
    Card,
    Button,
    PullRefresh,
          Dialog
  } from "vant";
  import FloatBtn from "@/components/FloatBtn";

  export default {
    components: {
      [Button.name]:Button,
      [Card.name]:Card,
      [NoticeBar.name]:NoticeBar,
      [Image.name]:Image,
      [Search.name]: Search,
      [Swipe.name]: Swipe,
      [SwipeItem.name]: SwipeItem,
      [NavBar.name]: NavBar,
      [Row.name]: Row,
      [Col.name]: Col,
      [Icon.name]: Icon,
      [Tabs.name]: Tabs,
      [Tab.name]: Tab,
      [ActionSheet.name]: ActionSheet,
      [Popup.name]: Popup,
      [PullRefresh.name]:PullRefresh,
      [FloatBtn.name]:FloatBtn,
      [Dialog.name]:Dialog

    },
    name: "Home",
    data() {
      return {
        baseUrl:'http://localhost:8080/jeecg-boot/',
        refreshing:false,
        firstName:String,
        notice:String,
        title:false,
        titleList:[],
        oldValue:'',
        searchFlag:false,
        showMission: false, // 领红包弹出框
        showHbArea: false, //右下角红包区按钮
        activeUrl: "",
        showSearch: false,
        showDialog:false,
        searchValue: "",
        count: 0,
        uuid:'',
        indexPage: 1,
        hotGoods: [],
        saleGroupGoods: [],
        classList: [],
        classIdList:[],
        activeClass: 0,
        activeClassName: "",
        list: [],
        error: false,
        loading: false,
        finished: false,
        showActive: false,
        swiperList: [],
        token:'',
        copy_pass:'',
        clipboard:{},
        actions: [
          {
            name: "用户: ",
            subname: this.$store.state.userInfo.phone
          },
          {
            name: "退出登陆"
          }
        ]
      };
    },
    mounted() {
      //this.getSwiperList();
      this.getGoodsClass();
      //this.showHongBao();
      const script = document.createElement("script");
      script.src = "https://v1.cnzz.com/z_stat.php?id=1280870910&web_id=1280870910";   //该路径为点击统计代码后，页面中第一个 文字统计 script代码
      script.language = "JavaScript";
      document.body.appendChild(script);
      if (localStorage.uuid) {
        this.uuid = localStorage.uuid;
      }
    },
    watch: {
      uuid(newuuid) {
        localStorage.uuid = newuuid;
      }
    },
    computed: {},
    methods: {

      async deleteData(id){
        var that = this;
        var r = ''+id
        setTimeout(()=>{
                  that.$copyText(r).then( e => {
                    that.$layer.msg("复制成功")
                  }, function (e) {

                    that.$layer.msg("对不起出问题了")              //this.$layer.msg("对不起没有搜到哦要不换个词再试一下")
                  })
                },1

        )
      },
      gotoTb(){
        this.showDialog = false;
      },

      async getData(id) {
        var that = this;
        let url = this.baseUrl+'zb/zbItem1/copy'
        var params = {"id":id,"token":this.token,"uuid":localStorage.uuid}
        var res = await this.axios.post(url,params)
        //加密开始
        /*var getResultsStr = enc.Hex.parse(res.data)
        var str = enc.Base64.stringify(getResultsStr)
        var decrypted = AES.decrypt(str, enc.Utf8.parse('awoaixiaozhulmra'), {iv: enc.Utf8.parse('awoaixiaozhulmra'), mode: mode.CBC, padding: pad.Pkcs7})
        let data = decrypted.toString(enc.Utf8)
        let resultData = JSON.parse(data)*/
        //加密结束

        let resultData = res.data
        if(resultData.success) {
          this.copy_pass = resultData.message;
          this.showDialog = true;
         /* setTimeout(()=>{
            this.clipboard = new ClipboardJS('.slogan', {
              text: ()=> this.copy_pass
            });
           this.clipboard.on('success', function(e) {
              that.$layer.msg("复制成功 打开淘宝App抢购")
              this.clipboard.destroy();
            });
            this.clipboard.on('error', (e) => {
              that.$layer.msg("对不起出问题了")
              console.log(e);
              // this.clipboard.destroy();
            });
          })*/
        }else{
          that.$layer.msg("操作太频繁了 请联系小助理解决吧")
        }
      },



      copyDate(id){
        let url = this.baseUrl+'zb/zbItem1/copy'
        var params = {"id":id,"token":this.token,"uuid":localStorage.uuid}
        let that = this;
        this.axios.post(url,params).then(res => {
          var getResultsStr = enc.Hex.parse(res.data)
          var str = enc.Base64.stringify(getResultsStr)
          var decrypted = AES.decrypt(str, enc.Utf8.parse('awoaixiaozhulmra'), {iv: enc.Utf8.parse('awoaixiaozhulmra'), mode: mode.CBC, padding: pad.Pkcs7})
          let data = decrypted.toString(enc.Utf8)
          let resultData = JSON.parse(data)
          if(resultData.success){
            let rr = resultData.message;
           setTimeout(()=>{
              that.$copyText(rr).then( e => {
                that.$layer.msg("复制成功 打开淘宝App抢购")
              }, function (e) {

                that.$layer.msg("对不起出问题了")              //this.$layer.msg("对不起没有搜到哦要不换个词再试一下")
              })
                    },1

            )

          }else{
            this.$toast.fail('操作频率太快，请稍候重试')
          }

        });

      },
      openJd(href){
        window.open(href,"_blank")
      },
      mysearch(){
        this.searchFlag=true
        if(this.searchFlag){
          this.oldValue = this.titleList[0]
          this.titleList[0] = this.searchValue
        }
        // this.classList.unshift(this.searchValue)
        // this.classIdList.unshift(this.searchValue)
        // this.activeClassName = this.searchValue
        // this.activeClass = this.searchValue
        //this.classList[0]=this.searchValue
        if(this.searchValue == ''){
          this.$layer.msg('请输入关键词才能搜索哦')
          return
        }
        let url = this.baseUrl + 'zb/zbItem1/query?q='+this.searchValue;

        this.axios.get(url).then(res => {
          //加密开始
          /*var getResultsStr = enc.Hex.parse(res.data)
          var str = enc.Base64.stringify(getResultsStr)
          var decrypted = AES.decrypt(str, enc.Utf8.parse('awoaixiaozhulmra'), {iv: enc.Utf8.parse('awoaixiaozhulmra'), mode: mode.CBC, padding: pad.Pkcs7})
          let data = decrypted.toString(enc.Utf8)
          let resultData = JSON.parse(data)*/
          //加密结束

          let resultData = res.data
          if(resultData.success){
            this.list = resultData.result.pageList
            this.finished = true;
          }else{
            this.$layer.msg("对不起没有搜到哦要不换个词再试一下")
          }
        });
        //this.classIdList.unshift(this.searchValue)
        //this.activeClassName = this.searchValue
      },
      //判断是否显示领取红包弹框
      onCopy: function (e) {
        // console.log(e)
        // console.log(e.text)
        //this.$layer.msg('复制成功快打开淘宝快去抢购吧');
        window._czc.push(['_trackEvent', '查看', e.text]);
        // let url = 'http://192.168.50.11:8080/jeecg-boot/zb/zbItem/log?zbid='+e.text;
        // this.axios.get(url).then(res => {
        // });
        //let resultData =  zbLog(e.text);
      },
      onError: function (e) {
        this.$layer.msg('出现问题再点一次吧');
      },
      showHongBao() {
        let url = `/pophb`;
        this.axios.get(url).then(res => {
          let hashb = res.data.data.hasHb;
          this.activeUrl = res.data.data.url;
          if (hashb) {
            this.showHbArea = false;
            this.showMission = true;
          } else {
            this.showHbArea = true;
            this.showMission = false;
          }
        });
      },
      getSwiperList() {
        let url = `/poster`;
        this.axios.get(url).then(res => {
          let data = res.data;
          this.swiperList = data.data;
        });
      },
      /*gotoPage(swiper) {
        if (swiper.taotoken) {
          var clipboard = new Clipboard(".copy-swiper");
          clipboard.on("success", e => {
            this.$toast(`复制成功`);
            // 释放内存
            clipboard.destroy();
            window.location.href = "taobao://";
          });
          clipboard.on("error", e => {
            // 不支持复制
            console.log("该浏览器不支持自动复制");
            // 释放内存
            clipboard.destroy();
            window.location.href = swiper.picthref;
          });
        } else {
          window.location.href = swiper.picthref;
        }
      },*/

      gotoLogin() {
        this.$router.push("/login");
      },
      onSelectAction(item) {
        this.showActive = false;
        if (item.name == "退出登陆") {
          localStorage.removeItem("userInfo");
          this.$store.commit("setLogin", false);
          this.$store.commit("setUserInfo", "");
        }
      },
      getGoodsClass() {
        /*let url = `/g/yiji`;
        this.axios.get(url).then(res => {
          let data = res.data;
          this.classList = data.data;
          if (this.classList.length > 0) {
            this.activeClassName = this.classList[0];
            this.getClassGoods();
          }
        });*/
        let url = this.baseUrl + '/zb/jrzb1/list';
        this.axios.get(url).then(res => {
          this.classList = []
          this.classIdList = []
          this.titleList = []
          //加密开始
          /*var getResultsStr = enc.Hex.parse(res.data)
          var str = enc.Base64.stringify(getResultsStr)
          var decrypted = AES.decrypt(str, enc.Utf8.parse('awoaixiaozhulmra'), {iv: enc.Utf8.parse('awoaixiaozhulmra'), mode: mode.CBC, padding: pad.Pkcs7})

          let data = decrypted.toString(enc.Utf8)

          let resultData = JSON.parse(data).result
          let a = JSON.parse(data)

          //let resultData = res.data.result
          if(localStorage.uuid == null){
            localStorage.uuid = res.data.message
          } */
          //加密结束
          let resultData = res.data.result
          if(localStorage.uuid == null){
            localStorage.uuid = res.data.message
          }
          for(let i=0; i<resultData.length; i++){
            let x = resultData[i]
            this.classList.push(x.name)
            this.classIdList.push(x.id)
            this.titleList.push(x.name)
            if(i ==1) {
              this.firstName = x.id
            }
          }
          this.oldValue = this.titleList[0]

          if (this.classIdList.length > 0) {
            this.activeClassName = this.classIdList[0];
            this.getClassGoods();
          }
        });

      },
      doSearch() {
        this.$router.push("/search");
      },
      onTabChange(item, title) {
        this.finished = false;
        this.searchFlag=false
        this.titleList[0] = this.oldValue
        this.activeClassName = this.classIdList[item]
        this.list = [];
        this.indexPage = 1;
        if(!this.searchFlag)
          this.getClassGoods();
      },
      onRefresh() {

      },
      onLoad() {
        setTimeout(() => {
          this.indexPage += 1;
          this.getClassGoods();
        },1000)
      },
      getClassGoods() {
        let url = "";
        if (this.activeClassName) {
          url = this.baseUrl + 'zb/zbItem1/list?zbid='+this.activeClassName+'&pageNo='+this.indexPage;
        } else {
          url = `/g/goods`;
        }

        this.axios.get(url).then(res => {
          //加密开始
          /*var getResultsStr = enc.Hex.parse(res.data)
          var str = enc.Base64.stringify(getResultsStr)
          var decrypted = AES.decrypt(str, enc.Utf8.parse('awoaixiaozhulmra'), {iv: enc.Utf8.parse('awoaixiaozhulmra'), mode: mode.CBC, padding: pad.Pkcs7})
          let data = decrypted.toString(enc.Utf8)
          let resultData = JSON.parse(data)
          //let resultData = res.data
           this.token = res.data.message;*/
          //加密结束

          let resultData = res.data
          this.token = res.data.message
          //let resultData = res.data
          if(resultData.result.pageList.length>0){
            for(let i=0;i<resultData.result.pageList.length;i++){
              this.list.push(resultData.result.pageList[i])
            }
            this.notice = resultData.result.title
            this.loading = false;
          }else{
            this.finished = true;
          }
        });
      },
      gotoDetail(item) {
        this.$router.push(`/goods?keyword=${item.details}`);
      }
    }
  };
</script>


<style lang="less" scoped>
  .home {
    background-color: #eee;
    margin-bottom: 0px;
    overflow:hidden;
    height:100%

  }
  .home-swipe {
    box-sizing: border-box;
    padding: 4px 6px;
    background-color: #fff;
    border-bottom: 1px solid #dedede;
    margin-bottom: 5px;
    &-head {
      padding: 4px 0;
      .recommend {
        font-weight: 700;
      }
      .tips {
        font-size: 12px;
        margin-left: 6px;
        color: #8f8f8f;
      }
      .swipe-num {
        float: right;
        .indexPage {
          font-weight: 700;
        }
        .pageNum {
          font-size: 12px;
          color: #8f8f8f;
        }
      }
    }
    .swipe {
      img {
        width: 100%;
      }
    }
  }
  .search-part {
    padding: 10px;
    color: rgba(69, 90, 100, 0.6);
  }

  .goods-list {
    margin-top: 5px;
    left: 5px;
    background-color: #ffffff;
    .good-item {
    ;
      border-radius: 20px;
      margin-top: 10px;
      margin-left: 9px;
      margin-right: 3px;
      img {
        width: 100%;
        border-radius: 20px 20px 0 0;
      }
      img::after {
        position: relative;
        padding-top: 100%;
      }
      .name {
        width: 92%;
        height: 38px;
        padding: 5px 4%;
        text-align: justify;
        overflow: hidden;
        font-size: 15px;
        white-space: normal;
        text-overflow: ellipsis;
      }
      .info {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        width: 92%;
        padding: 5px 4% 5px 4%;
        .oldprice {
          color: #888;
          font-size: 15px;
          text-decoration: line-through;
        }
        .price {
          color: #888;
          font-size: 15px;
        }
        .needsclick{
          color: #fff;
          background-color: #ff6600;
          padding: 4px;
          font-size: 16px;
          font-weight: 600;
        }
        .slogan {
          color: #fff;
          background-color: #ff6600;
          padding: 4px;
          font-size: 16px;
          font-weight: 600;
        }
        .back {
          padding: 2px;
          font-size: 14px;
          font-weight: 600;
          color: #999;
        }
        .sell {
          color: #888;
          font-size: 13px;
        }
      }
    }
    .good-item2 {
    ;
      border-radius: 20px;
      margin-top: 10px;
      margin-left: 3px;
      margin-right:9px;
      img {
        width: 100%;
        border-radius: 20px 20px 0 0;
      }
      img::after {
        position: relative;
        padding-top: 100%;
      }
      .name {
        width: 92%;
        height: 38px;
        padding: 5px 4%;
        text-align: justify;
        overflow: hidden;
        font-size: 15px;
        white-space: normal;
        text-overflow: ellipsis;
      }
      .info {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        width: 92%;
        padding: 5px 4% 5px 4%;
        .oldprice {
          color: #888;
          font-size: 15px;
          text-decoration: line-through;
        }
        .price {
          color: #888;
          font-size: 15px;
        }
        .slogan {
          color: #fff;
          background-color: #ff6600;
          padding: 4px;
          font-size: 16px;
          font-weight: 600;
        }
        .needsclick {
          color: #fff;
          background-color: #ff6600;
          padding: 4px;
          font-size: 16px;
          font-weight: 600;
        }
        .back {
          padding: 2px;
          font-size: 14px;
          font-weight: 600;
          color: #999;
        }
        .sell {
          color: #888;
          font-size: 13px;
        }
      }
    }
  }
  .pop-box {
    border-radius: 10px;
    background-color: rgba(0, 0, 0, 0);
    padding: 0;
  }


</style>